import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Input, Row, Col, Select, Spin } from 'antd';
import { get, save, setPending } from '../redux/actions/insumoActions';
import {
  ExclamationCircleOutlined,
  PlusOutlined,
  EditOutlined,
} from '@ant-design/icons';
import ProveedorEditor from './ProveedorEditor';
import { setPending as setPendingProveedor } from '../redux/actions/proveedorActions';
import { compareObject } from '../utils/funtions';
import { callStatus } from '../utils/constants';

import cloneDeep from 'lodash/cloneDeep';
import { Notificacion } from './Notificacion';

import {
  DraggableModal,
  DraggableModalProvider,
} from 'ant-design-draggable-modal';
const { confirm } = Modal;
const { Option } = Select;

const InsumoEditor = ({
  dispatch,
  id,
  stateData,
  visible,
  onCancel,
  proveedor,
  insumoTipo,
}) => {
  const [form] = Form.useForm();
  const [proveedorData, setProveedorData] = useState([]);
  const [showEditProveedor, setShowEditProveedor] = useState(false);
  const [proveedorIdEdit, setProveedorIdEdit] = useState(null);
  const [proveedorIdSelected, setProveedorIdSelected] = useState(null);

  const handleHideProveedorEditor = () => {
    setShowEditProveedor(false);
    setProveedorIdEdit(null);
    dispatch(setPendingProveedor());
  };

  const handleProveedorEdit = () => {
    setProveedorIdEdit(proveedorIdSelected);
    setShowEditProveedor(true);
  };

  const handleProveedorCreate = () => {
    setProveedorIdEdit(null);
    setShowEditProveedor(true);
  };

  useEffect(() => {
    if (
      proveedor.object.status === callStatus.OBJECT_SAVE_SUCCESS &&
      showEditProveedor
    ) {
      const saved = proveedor.object.data;
      setResultSearchProveedor((prev) => {
        if (!prev.some((p) => p.id === saved.id)) {
          return [...prev, saved];
        }
        return prev.map((p) => (p.id === saved.id ? saved : p));
      });
      form.setFieldsValue({ proveedor_id: saved.id });
      setProveedorIdSelected(saved.id);
    }
  }, [proveedor.object.status, showEditProveedor, proveedor.object.data, form]);

  useEffect(() => {
    if (id) {
      if (String(stateData.object.data?.id) !== String(id)) {
        dispatch(get(id));
      }
    } else {
      dispatch(setPending());
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setProveedorData(proveedor.list.data.filter((item) => item.tipo_id === 1));
    // eslint-disable-next-line
  }, [proveedor]);

  useEffect(() => {
    let data = cloneDeep(stateData.object.data);
    if (stateData.object.status === callStatus.OBJECT_SUCCESS) {
      if (data.proveedor) {
        setResultSearchProveedor([data.proveedor]);
      }

      form.setFieldsValue(data);
      setInitial(data);
      setProveedorIdSelected(data.proveedor_id || null);
    } else if (stateData.object.status === callStatus.OBJECT_PENDING) {
      form.resetFields();
      setInitial({});
      setResultSearchProveedor([]);
      setProveedorIdSelected(null);
    } else if (stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS) {
      Notificacion('El registro se guardó con éxito', 'success', onCancel);
    } else if (stateData.object.status === callStatus.OBJECT_FAILED) {
      Notificacion(stateData.object.error, 'error', () => {});
    }

    // eslint-disable-next-line
  }, [stateData.object]);

  const onCreate = (data) => {
    dispatch(save(data));
  };

  const [initial, setInitial] = useState({});

  const handleOnCancel = () => {
    if (compareObject(initial, form.getFieldsValue())) {
      confirm({
        title: 'Posee cambios sin guardar, desea continuar?',
        icon: <ExclamationCircleOutlined />,
        okText: 'Si',
        cancelText: 'No',
        autoFocusButton: 'cancel',
        onOk() {
          onCancel();
        },
        onCancel() {},
      });
    } else {
      onCancel();
    }
  };
  const [resultSearchProveedor, setResultSearchProveedor] = useState([]);

  const onSearchProveedor = (value) => {
    const result = proveedorData.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase())
    );
    setResultSearchProveedor(result);
  };
  return (
    <>
      <DraggableModalProvider>
        <DraggableModal
          mask
          initialWidth={500}
          initialHeight={400}
          maskClosable={false}
          visible={visible}
          title={stateData.object.data.id ? 'Editar Insumo' : 'Nuevo Insumo'}
          okText="Guardar"
          cancelText="Salir"
          onCancel={handleOnCancel}
          onOk={() => {
            form
              .validateFields()
              .then((values) => {
                onCreate(values);
              })
              .catch((info) => {
                console.log('Validate Failed:', info);
              });
          }}
        >
          <Spin
            spinning={
              stateData.object.status === callStatus.OBJECT_IN_PROCESS ||
              !!(id && stateData.object.status === callStatus.OBJECT_PENDING)
            }
          >
            <Form form={form} layout="vertical" name="form_in_modal">
              <Row gutter={[8, 0]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item name="id" label="id" style={{ display: 'none' }}>
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[8, 0]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item
                    name="nombre"
                    label="Nombre"
                    rules={[
                      {
                        required: true,
                        message: 'Requerido',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Form.Item
                      name="proveedor_id"
                      label="Proveedor"
                      style={{ flex: 1 }}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={onSearchProveedor}
                        onChange={(val) => setProveedorIdSelected(val)}
                        notFoundContent={null}
                        allowClear
                      >
                        {resultSearchProveedor.map((item, index) => (
                          <Option key={index} value={item.id}>
                            {item.nombre}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <div>
                      {proveedorIdSelected ? (
                        <EditOutlined
                          onClick={handleProveedorEdit}
                          style={{ paddingLeft: '7px', cursor: 'pointer' }}
                        />
                      ) : (
                        <PlusOutlined
                          onClick={handleProveedorCreate}
                          style={{ paddingLeft: '7px', cursor: 'pointer' }}
                        />
                      )}
                    </div>
                  </div>
                </Col>
                <Col xs={24} sm={24} md={10} lg={10} xl={10}>
                  <Form.Item name="precio" label="Precio">
                    <Input type="number" addonBefore="U$D" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={14} lg={14} xl={14}>
                  <Form.Item name="tipo_id" label="Tipo de Insumo">
                    <Select allowClear>
                      {insumoTipo?.list?.data?.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </DraggableModal>
        {showEditProveedor ? (
          <ProveedorEditor
            id={proveedorIdEdit}
            onCancel={handleHideProveedorEditor}
            visible={true}
          />
        ) : (
          false
        )}
      </DraggableModalProvider>{' '}
    </>
  );
};

const mapStateToProps = (state) => {
  const { insumo, proveedor, insumoTipo } = state;
  const stateData = insumo;
  return {
    stateData,
    proveedor,
    insumoTipo,
  };
};
export default connect(mapStateToProps)(InsumoEditor);
